export const POST = 'co_theme/routes/POST'
export const FRONTPAGE = 'co_theme/routes/FRONTPAGE'
